import React, { Component } from 'react';

class WXConfig extends Component {

  componentDidMount(){
    let {title, desc, imgUrl, link} = this.props
    console.log('componentDidMount', title, desc, imgUrl, link)
    Promise.resolve(window.wx).then((wx)=>{
      if(!wx){
        return
      }
      wx.ready(function () {
        wx.onMenuShareTimeline({
          title: title || "「你好，朋友」",
          desc: desc || "有一种说法「艺术是提出问题，而非给出答案」，「你好，朋友」邀请你在这里直接提出和讨论问题。",
          link: link || window.location.href,
          imgUrl: imgUrl || window.location.protocol+'//'+window.location.host+"/logo.png",
          success: function (res) {
            console.log('success onMenuShareTimeline', res)
          },
          cancel: function (res) {
            console.log('cancel onMenuShareTimeline', res)
          },
          fail: function (res) {
            window.Raven.captureMessage(JSON.stringify({
              res,
              location: window.location,
              type: 'onMenuShareTimeline'
            }))
          }
        });
        wx.onMenuShareAppMessage({
          title: title || "「你好，朋友」",
          desc: desc || "有一种说法「艺术是提出问题，而非给出答案」，「你好，朋友」邀请你在这里直接提出和讨论问题。",
          link: link || window.location.href,
          imgUrl: imgUrl || window.location.protocol+'//'+window.location.host+"/logo.png",
          success: function (res) {
            console.log('success onMenuShareAppMessage', res)
          },
          cancel: function (res) {
            console.log('cancel onMenuShareAppMessage', res)
          },
          fail: function (res) {
            window.Raven.captureMessage(JSON.stringify({
              res,
              location: window.location,
              type: 'onMenuShareAppMessage'
            }))
          }
        });
      });
    })
  }

  render(){
    return <div style={{display:"none"}} />
  }

}

export default WXConfig





// WEBPACK FOOTER //
// ./src/WXConfig.js